import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/project-color-list';

//projects only field
export default class ProjectColorField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.PROJECT_COLOR;
    }

    get sortHintMessage() {
        return 'Sort by color';
    }

    getCsvValue(item) {
        return item.color;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.color],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }
}